<template>
  <v-card inline class="px-5 py-5">
    <v-card-title>
      <div class="title text-no-wrap font-weight-bold">
        {{ $t("newTask.titles.onetime") }}
        <br />
        <span
          v-if="equipmentProfile && equipmentProfile.equipTag"
          class="caption"
          >{{ $t("newTask.labels.tag") }}: {{ equipmentProfile.equipTag }}</span
        >
      </div>
    </v-card-title>

    <v-form dark ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12" md="12" justify="center" align="center">
            <v-text-field
              filled
              :rules="requireRules"
              v-model="taskInformation.name"
              :label="this.$t('newTask.labels.name')"
            ></v-text-field> </v-col
          ><v-col cols="12" md="12" justify="center" align="center">
            <v-textarea
              filled
              :rules="requireRules"
              v-model="taskInformation.description"
              :label="this.$t('newTask.labels.description')"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6" justify="center" align="center">
            <v-select
              :label="$t('newTask.labels.type')"
              v-model="taskInformation.subtype"
              :items="taskSubtypes"
              item-text="translation"
              return-object
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="6" justify="center" align="center">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="taskInformation.initialDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="taskInformation.initialDate"
                  label="Due Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  filled
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="taskInformation.initialDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  {{ $t("newTask.buttons.cancel") }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(taskInformation.initialDate)"
                >
                  {{ $t("newTask.buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>

        <v-divider class="my-2"></v-divider>
        <div class="title  primary--text">
          {{ $t("newTask.headers.notificationFrequency") }}
        </div>
        <div class="caption">
          {{ $t("newTask.messages.taskFrequency") }}
        </div>
        <v-row>
          <v-col cols="6" justify="center" align="center">
            <v-text-field
              clearable
              clear-icon="mdi-cancel"
              :rules="timeRules"
              v-model="valueAlertTime"
              :label="$t('newTask.labels.alertTime')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="selectedAlertTime"
              :items="timeObj"
              item-text="name"
              return-object
            >
            </v-select>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-btn
          block
          x-large
          color="primary"
          class="elevation-8 font-weight-bold mr-4 mb-4"
          :disabled="!valid"
          @click="validate"
          >{{ $t("newTask.buttons.submit") }}</v-btn
        >
        <v-btn
          block
          x-large
          color="primary"
          class="elevation-8 font-weight-bold mr-4"
          @click="$emit('cancelTask')"
          >{{ $t("newTask.buttons.cancel") }}</v-btn
        >
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { db, timestamp } from "@/plugins/db";

export default {
  name: "ModalNewTask",
  props: ["user", "equipmentProfile"],
  computed: {
    changeTimeRealValue() {
      return this.valueChangeTime * this.selectedChangeTime.value;
    },
    alertTimeRealValue() {
      return this.valueAlertTime * this.selectedAlertTime.value;
    }
  },
  created() {},
  data() {
    return {
      modal: false,
      timeObj: [
        { name: this.$t("newTask.date.year"), value: 31536000 },
        { name: this.$t("newTask.date.month"), value: 2592000 },
        { name: this.$t("newTask.date.week"), value: 604800 },
        { name: this.$t("newTask.date.day"), value: 86400 }
      ],
      taskSubtypes: [
        {
          name: "maintenance",
          translation: this.$t("newTask.labels.subtypes.maintenance")
        },
        {
          name: "repair",
          translation: this.$t("newTask.labels.subtypes.repair")
        },
        {
          name: "reliability",
          translation: this.$t("newTask.labels.subtypes.reliability")
        }
      ],
      taskInformation: {
        name: "",
        initialDate: new Date().toISOString().substring(0, 10),
        changeTime: 0,
        alertTime: 0,
        type: "unique"
      },
      selectedChangeTime: { name: this.$t("newTask.date.day"), value: 86400 },
      selectedAlertTime: { name: this.$t("newTask.date.day"), value: 86400 },
      valueChangeTime: 0,
      valid: false,
      valueAlertTime: 0,
      requireRules: [v => !!v || this.$t("newConsumable.mandatoryField")],
      timeRules: [v => v > 0 || this.$t("newConsumable.greaterThanZero")]
    };
  },
  methods: {
    async validate() {
      const res = await this.$dialog.confirm({
        text: this.$t("dashboard.canYouConfirm"),
        title: this.$t("dashboard.checkFields")
      });
      if (res == true) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });

        let payload = {
          db: "calendar",
          data: {
            disabled: false,
            dateCreated: timestamp,
            createdBy: this.user.email,
            equipmentProfile: db
              .collection("equipments")
              .doc(this.equipmentProfile.id),
            name: this.taskInformation.name,
            description: this.taskInformation.description,
            details: this.taskInformation.description,
            start: this.taskInformation.initialDate,
            end: this.taskInformation.initialDate,
            lastChange: this.taskInformation.initialDate,
            changeTime: this.changeTimeRealValue,
            alertTime: this.alertTimeRealValue,
            type: this.taskInformation.type,
            subtype: this.taskInformation.subtype.name,
            disabledArray: [],
            baseLink: "/task-profile/",
            isDone: false
          }
        };

        try {
          const responseUid = await this.$store.dispatch(
            "addDocument",
            payload
          );
          this.responseUid = responseUid;

          await this.$emit("createInspectionAfterTask", true, this.responseUid);

          this.$dialog.notify.success(
            "Your new recurring task has been created successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );

          this.taskInformation = {
            name: "",
            initialDate: new Date().toISOString().substring(0, 10),
            changeTime: 0,
            alertTime: 0,
            type: "unique"
          };
          this.$refs.form.reset();
          (this.selectedChangeTime = {
            name: this.$t("newTask.date.day"),
            value: 86400
          }),
            (this.selectedAlertTime = {
              name: this.$t("newTask.date.day"),
              value: 86400
            }),
            loading.close();
        } catch (error) {
          console.error(error);
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
        loading.close();
      }
    }
  }
};
</script>
